import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service Worker 등록 - 업데이트 확인
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log('🆕 새 버전 감지!');
    
    const confirmed = window.confirm(
      '새로운 버전이 출시되었습니다!\n\n' +
      '지금 업데이트하시겠습니까?\n' +
      '(확인을 누르면 페이지가 새로고침됩니다)'
    );
    
    if (confirmed) {
      const waitingServiceWorker = registration.waiting;
      
      if (waitingServiceWorker) {
        // Service Worker 활성화 완료 후 페이지 새로고침
        waitingServiceWorker.addEventListener('statechange', (event) => {
          if (event.target.state === 'activated') {
            window.location.reload();
          }
        });
        
        // Service Worker에게 즉시 활성화 요청
        waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
      }
    } else {
      console.log('⏸️ 업데이트를 거부했습니다. 다음 방문 시 적용됩니다.');
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
